import { IFilters } from "constants/filters";
import { ReportDistribution } from "constants/reports/distribution";
import { Last7DaysMode } from "constants/reports/last-7-days-mode";
import { ReportExportType, ReportType } from "constants/reports/report-type";
import { DetailedSource } from "interfaces/entities/ticket";
import { ActionsUnion, createAction } from "store/helper";

import {
  IReportCreatePayload,
  IReportsViewSetQueryParamsFromURLPayload,
  IScheduledReport,
  IScheduledReportDelete,
  IScheduledReportEdit,
} from "./interfaces";

export enum ReportsViewActionsNames {
  INITED = "VIEWS/REPORT/INITED",
  SET_CURRENT_VIEW = "VIEWS/REPORT/SET_CURRENT_VIEW",
  FETCH_DATA = "VIEWS/REPORT/FETCH_DATA",
  FETCH_HEATMAP_DATA = "VIEWS/REPORT/FETCH_HEATMAP_DATA",
  CREATE_REPORT = "VIEWS/REPORT/CREATE_REPORT_REQUEST",
  CREATE_SCHEDULED_REPORT_SUCCESS = "VIEWS/REPORT/CREATE_REPORT_SUCCESS",
  EDIT_SCHEDULED_REPORT = "VIEWS/REPORT/EDIT_SCHEDULED_REPORT_REQUEST",
  EDIT_SCHEDULED_REPORT_SUCCESS = "VIEWS/REPORT/EDIT_SCHEDULED_REPORT_SUCCESS",
  DELETE_SCHEDULED_REPORT = "VIEWS/REPORT/DELETE_SCHEDULED_REPORT_REQUEST",
  DELETE_SCHEDULED_REPORT_SUCCESS = "VIEWS/REPORT/DELETE_SCHEDULED_REPORT_SUCCESS",
  SET_DATA = "VIEWS/REPORT/SET_DATA",
  SET_QUERY_PARAMS_FROM_URL = "VIEWS/REPORT/SET_QUERY_PARAMS_FROM_URL",
  SET_DISTRIBUTION = "VIEWS/REPORT/SET_DISTRIBUTION",
  UPDATE_FILTER = "VIEWS/REPORT/UPDATE_FILTER",
  FETCH_TAGS = "VIEWS/REPORT/FETCH_TAGS",
  SET_LAST_7_DAYS_MODE = "VIEWS/REPORT/SET_LAST_7_DAYS_MODE",
  SET_LAST_7_DAYS_FILTERS = "VIEWS/REPORT/SET_LAST_7_DAYS_FILTERS",
  SET_CACHE_EXPIRATION_TIME = "VIEWS/REPORT/SET_CACHE_EXPIRATION_TIME",
  GENERATE_REPORT_REQUEST = "VIEWS/REPORT/GENERATE_REPORT_REQUEST",
  GENERATE_REPORT_SUCCESS = "VIEWS/REPORT/GENERATE_REPORT_SUCCESS",
  GENERATE_REPORT_FAILURE = "VIEWS/REPORT/GENERATE_REPORT_FAILURE",
  SET_LAST_AVAILABLE_SOURCES = "VIEWS/REPORT/SET_LAST_AVAILABLE_SOURCES",
}

export const ReportsViewActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  inited: () => createAction(ReportsViewActionsNames.INITED),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setCurrentView: (reportType: ReportType) =>
    createAction(ReportsViewActionsNames.SET_CURRENT_VIEW, { reportType: reportType || ReportType.Last7days }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchData: (reportType: ReportType, forceRefetch?: boolean) =>
    createAction(ReportsViewActionsNames.FETCH_DATA, { reportType, forceRefetch }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchHeatmapData: (reportType: ReportType) =>
    createAction(ReportsViewActionsNames.FETCH_HEATMAP_DATA, { reportType }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createReport: (data: IReportCreatePayload) => createAction(ReportsViewActionsNames.CREATE_REPORT, { data }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createReportSuccess: (data: IScheduledReport) =>
    createAction(ReportsViewActionsNames.CREATE_SCHEDULED_REPORT_SUCCESS, { data }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  editScheduledReport: (data: IScheduledReportEdit) =>
    createAction(ReportsViewActionsNames.EDIT_SCHEDULED_REPORT, { data }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  editScheduledReportSuccess: (data: IScheduledReportEdit) =>
    createAction(ReportsViewActionsNames.EDIT_SCHEDULED_REPORT_SUCCESS, { data }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteScheduledReport: (data: IScheduledReportDelete) =>
    createAction(ReportsViewActionsNames.DELETE_SCHEDULED_REPORT, { data }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteScheduledReportSuccess: (data: IScheduledReportDelete) =>
    createAction(ReportsViewActionsNames.DELETE_SCHEDULED_REPORT_SUCCESS, { data }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setReportData: <TData>(reportType: ReportType, data: TData) =>
    createAction(ReportsViewActionsNames.SET_DATA, { reportType, data }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setReportDistribution: (type: ReportDistribution = ReportDistribution.Day) =>
    createAction(ReportsViewActionsNames.SET_DISTRIBUTION, { type }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchTags: () => createAction(ReportsViewActionsNames.FETCH_TAGS),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateFilter: (payload: IFilters) => createAction(ReportsViewActionsNames.UPDATE_FILTER, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setQueryParamsFromURL: (payload: IReportsViewSetQueryParamsFromURLPayload) =>
    createAction(ReportsViewActionsNames.SET_QUERY_PARAMS_FROM_URL, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setLast7DaysMode: (last7DaysMode: Last7DaysMode) =>
    createAction(ReportsViewActionsNames.SET_LAST_7_DAYS_MODE, { last7DaysMode }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setLast7DaysFilters: (resetFilters: boolean) =>
    createAction(ReportsViewActionsNames.SET_LAST_7_DAYS_FILTERS, { resetFilters }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setCacheExpirationTime: (reportType: ReportType, expirationTime: Date) =>
    createAction(ReportsViewActionsNames.SET_CACHE_EXPIRATION_TIME, { reportType, expirationTime }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  generateReport: (type: ReportExportType, from: Date, to: Date, recipients: string[]) =>
    createAction(ReportsViewActionsNames.GENERATE_REPORT_REQUEST, { type, from, to, recipients }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  generateReportSuccess: () => createAction(ReportsViewActionsNames.GENERATE_REPORT_SUCCESS, {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  generateReportFailure: (reason: string, limitExceededReason?: string) =>
    createAction(ReportsViewActionsNames.GENERATE_REPORT_FAILURE, { reason, limitExceededReason }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setLastAvailableSources: (sources: DetailedSource[]) =>
    createAction(ReportsViewActionsNames.SET_LAST_AVAILABLE_SOURCES, { sources }),
};

export type ReportsViewAction = ActionsUnion<typeof ReportsViewActions>;
